import collectionDetailsSymbols from "../symbols/collectionDetails";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function CollectionDetailsSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case collectionDetailsSymbols.GET_COLLECTION_DETAILS:
      return { ...state, loading: true, error: false };
    case collectionDetailsSymbols.GET_COLLECTION_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case collectionDetailsSymbols.GET_COLLECTION_DETAILS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case collectionDetailsSymbols.CLEAR_GET_COLLECTION_DETAILS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
